import React, {useState} from 'react';
import {v4 as uuidv4} from 'uuid';

import { menu } from '../../../main/js/router/Menu';
import { i18ndb, rest } from '../services';

import "bootstrap/dist/css/bootstrap.css";
import "../widgets/react-bootstrap-ribbon/react-bootstrap-ribbon.css";
import '../pages/Form.css'
import { RibbonBrowser } from '../browsers/RibbonBrowser';
import { Welcome } from '../../../main/js/pages/Welcome';
import ActionAreaCard from '../widgets/ActionAreaCard';

export const displayRibbon = () => (menu) => {
    let uuid = uuidv4();
    return { 
        uuid, view: () => <RibbonBrowser menuSection={menu} welcome={(uuid)=><Welcome key={uuid}/>}/>    }
}

const buildSelectionRows = (options, gui) => {
  const items = []
  const optionsKeys = Object.keys(options);  
  let rowSize = 2;
  const rows = [];
  optionsKeys.forEach((key, index) => {
    items.push(
      <div style={{marginBottom: '20px', textAlign: (options[key].content)?'left':'center', width: (options[key].content)?'100%':'inherit'}}>
        <ActionAreaCard content={(options[key].content)?options[key].content(gui):null} onClick={() => (options[key].content)?null:gui.goTo(displayRibbon(), options[key])} description={i18ndb._(options[key].description)} title={i18ndb._(options[key].label)}/>
      </div>
    )
  });
  for (let i = 0; i < optionsKeys.length; i += rowSize) {
    if (i > 1) {
      rowSize = 3;
      rows.push(items.slice(i, i + rowSize));  
    }
    else
      rows.push(items.slice(i, i + rowSize));
  }

	return rows;
}


export function WelcomePage({gui}) {
    const [perspective, setPerspective] = useState(menu());
    return (
      <>
      {buildSelectionRows(perspective, gui).map((row, rowIndex) => (
        <div key={rowIndex} style={{
          margin: '30px',
          position: 'relative',
          transform: `translate(0%, ${(rowIndex !== 0)?15 * (rowIndex + 1):0}%)`,
          width: '97%',
          display: 'flex',
          justifyContent: 'space-around'
        }}>
          {row}
        </div>
      ))}
      </>
    );
}

